import { defineStore } from 'pinia';

interface RepaymentState {
  interestsCardChecked: boolean; //是否选择收益卡
}

export const useRepaymentStore = defineStore('repayment', {
  state: (): RepaymentState => ({
    interestsCardChecked: false,
  }),
  getters: {
    record(state) {
      return {
        interestsCardChecked: state.interestsCardChecked,
      };
    },
  },
  actions: {
    saveRecord(payload: Partial<RepaymentState>) {
      this.interestsCardChecked = payload.interestsCardChecked ?? this.interestsCardChecked;
    },
    clearRecord() {
      this.interestsCardChecked = false;
    },
  },
  persist: true,
});
